import CreateNewPipelineAction from './CreateNewPipelineAction.vue';

export default {
  CreateNewPipelineAction,
};
